// @ts-nocheck
import { useGeoFenceRepository } from '../repositories';
// TODO: Violations, bulk-review, employee locations, update, and delete are
// specialized operations not covered by the GeoFence repository's CRUD.
// Remove compat imports once the repository supports these operations.
import { useCompatQuery, useCompatMutation } from './useApolloCompat';
import {
  UPDATE_GEO_FENCE_MUTATION,
  DELETE_GEO_FENCE_MUTATION,
  GEO_FENCE_VIOLATIONS_QUERY,
  REVIEW_GEO_FENCE_VIOLATION_MUTATION,
  BULK_REVIEW_VIOLATIONS_MUTATION,
  EMPLOYEE_LOCATIONS_QUERY,
} from '../graphql/operations';
import type { GeoFence, GeoFenceViolation, EmployeeLocation } from '../types/geofencing';

// ── Hooks ───────────────────────────────────────────────────────────

export function useGeoFences(variables?: { page?: number; perPage?: number }) {
  const repo = useGeoFenceRepository();
  return repo.useList(variables);
}

export function useGeoFence(id: string) {
  const repo = useGeoFenceRepository();
  return repo.useGet(id);
}

export function useCreateGeoFence() {
  const repo = useGeoFenceRepository();
  const { create, loading, error } = repo.useCreate();
  return {
    mutate: (input: any) => create(input),
    mutateAsync: (input: any) => create(input),
    isPending: loading,
    loading,
    error,
  };
}

// TODO: Migrate to repository pattern once GeoFence repository supports update.
export function useUpdateGeoFence() {
  return useCompatMutation(UPDATE_GEO_FENCE_MUTATION);
}

// TODO: Migrate to repository pattern once GeoFence repository supports delete.
export function useDeleteGeoFence() {
  return useCompatMutation(DELETE_GEO_FENCE_MUTATION);
}

// TODO: Migrate to repository pattern once a GeoFenceViolation repository exists.
export function useGeoFenceViolations(variables?: {
  geoFenceId?: string;
  employeeId?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  perPage?: number;
}) {
  return useCompatQuery(GEO_FENCE_VIOLATIONS_QUERY, { variables });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useReviewViolation() {
  return useCompatMutation(REVIEW_GEO_FENCE_VIOLATION_MUTATION, {
    refetchQueries: [{ query: GEO_FENCE_VIOLATIONS_QUERY }],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useBulkReviewViolations() {
  return useCompatMutation(BULK_REVIEW_VIOLATIONS_MUTATION, {
    refetchQueries: [{ query: GEO_FENCE_VIOLATIONS_QUERY }],
  });
}

// TODO: Migrate to repository pattern once an EmployeeLocation repository exists.
export function useEmployeeLocations() {
  return useCompatQuery(EMPLOYEE_LOCATIONS_QUERY, {
    pollInterval: 30000,
  });
}
